"use strict";

function stubArray() {
  return [];
}
module.exports = stubArray;